(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lp-theme-core"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-lp-toggle]');
    if (!trigger) return;

    const targetId = trigger.getAttribute('data-lp-toggle');
    const root = document.getElementById(targetId);

    if (!root) return;

    const expanded = root.getAttribute('data-open') === 'true';
    root.setAttribute('data-open', expanded ? 'false' : 'true');
  });

  document.addEventListener('click', (event) => {
    const closer = event.target.closest('[data-lp-close]');
    if (!closer) return;

    const targetId = closer.getAttribute('data-lp-close');
    const root = document.getElementById(targetId);

    if (root) {
      root.setAttribute('data-open', 'false');
    }
  });

  document.addEventListener('click', (event) => {
    const galleryButton = event.target.closest('[data-lp-thumb-index]');
    if (!galleryButton) return;

    const gallery = galleryButton.closest('[data-lp-gallery]');
    if (!gallery) return;

    const stage = gallery.querySelector('[data-lp-gallery-stage]');
    const thumbs = gallery.querySelectorAll('[data-lp-thumb-index]');

    if (!stage) return;

    const nextSrc = galleryButton.getAttribute('data-lp-image-src');
    const nextSrcset = galleryButton.getAttribute('data-lp-image-srcset');

    if (nextSrc) stage.setAttribute('src', nextSrc);
    if (nextSrcset) stage.setAttribute('srcset', nextSrcset);
    if (galleryButton.getAttribute('data-lp-image-alt')) {
      stage.setAttribute('alt', galleryButton.getAttribute('data-lp-image-alt'));
    }

    thumbs.forEach((thumb) => thumb.setAttribute('aria-pressed', 'false'));
    galleryButton.setAttribute('aria-pressed', 'true');
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    function attachProductMediaShimmer(img) {
    const container = img.closest('.product-media');
    if (!container) return;
    if (img.complete && img.naturalWidth > 0) {
      container.classList.add('product-media--loaded');
    } else {
      const markLoaded = () => container.classList.add('product-media--loaded');
      img.addEventListener('load', markLoaded, { once: true });
      img.addEventListener('error', markLoaded, { once: true });
    }
  }

  document.querySelectorAll('.product-media__image').forEach(attachProductMediaShimmer);

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches('.product-media__image')) {
          attachProductMediaShimmer(node);
        } else {
          node.querySelectorAll('.product-media__image').forEach(attachProductMediaShimmer);
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
  } catch(e) { console.error(e); }
})();

})();
